<template>
  <span class="smart-image">
    <img class="load" src="/static/img/loading.gif" alt="" height="30">
  </span>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '/static/img/file-thumb.jpg',
    },
  },

  beforeMount() {
    const img = new Image();
    img.onerror = () => {
      img.src = '/static/img/file-thumb.jpg';
    };
    img.onload = () => {
      $(this.$el).find('img.load').remove();
      $(this.$el).append(img);
    };
    img.src = this.src;
  },
};
</script>



// WEBPACK FOOTER //
// SmartImage.vue?4458f12c